import type { Likert, Question as QuestionType } from '../data/types';
import styles from './Question.module.css';

interface QuestionProps {
  question: QuestionType;
  index: number;
  total: number;
  value: Likert | undefined;
  onAnswer: (value: Likert) => void;
  onBack: () => void;
  canBack: boolean;
}

const LIKERT_LABELS: Record<Likert, string> = {
  1: 'not me at all',
  2: 'a little',
  3: 'somewhat',
  4: 'much',
  5: 'deeply me',
};

export function Question({
  question,
  index,
  total,
  value,
  onAnswer,
  onBack,
  canBack,
}: QuestionProps) {
  const pct = ((index + 1) / total) * 100;

  return (
    <section className={styles.frame}>
      <header className={styles.header}>
        <span className={styles.progressLabel}>
          question {index + 1} of {total}
        </span>
        <div className={styles.progressBar}>
          <div
            className={styles.progressFill}
            style={{ transform: `scaleX(${pct / 100})` }}
          />
        </div>
      </header>

      <p className={styles.prompt}>{question.prompt}</p>

      <fieldset className={styles.scaleRow}>
        <legend className={styles.scaleLegend}>rate how true this feels</legend>
        {[1, 2, 3, 4, 5].map((n) => {
          const k = n as Likert;
          return (
            <button
              key={n}
              type="button"
              className={`${styles.dot} ${value === n ? styles.dotActive : ''}`}
              aria-label={LIKERT_LABELS[k]}
              aria-pressed={value === n}
              onClick={() => onAnswer(k)}
            >
              <span className={styles.dotInner} />
              <span className={styles.dotLabel}>{LIKERT_LABELS[k]}</span>
            </button>
          );
        })}
      </fieldset>

      <div className={styles.actions}>
        {canBack && (
          <button type="button" className={styles.back} onClick={onBack}>
            ← back
          </button>
        )}
        {!canBack && <span />}
        {value != null ? (
          <span className={styles.advanceHint}>continuing…</span>
        ) : (
          <span className={styles.helper}>pick a position to continue</span>
        )}
      </div>
    </section>
  );
}
